/* The access token lives in this module only: never in storage, a cookie or a URL. */

let accessToken: string | null = null;
let sessionGone = false;

export function getToken(): string | null {
  return accessToken;
}

export function setToken(token: string | null): void {
  accessToken = token;
  if (token) sessionGone = false;
}

/** Latched when a refresh fails, so later 401s stop asking. */
export function isSessionGone(): boolean {
  return sessionGone;
}

export function markSessionGone(): void {
  sessionGone = true;
}

export function clearToken(): void {
  accessToken = null;
}
